<template>
  <!-- eslint-disable -->
  <div class="page-container">
    <div class="column-left">
      <SideNav />
    </div>

    <div class="column-right">
      <TopNav />
      
      <div class="detalle-container">
        <div class="order-header-card">
          <div class="header-main-info">
            <div class="order-badge">Orden #{{ $route.params.ordenId }}</div>
            <h1 class="main-title">Detalles de Atención</h1>
          </div>
          
          <div class="address-grid">
            <div class="address-item">
              <span class="label">Dirección de Atención</span>
              <span class="value">{{ direccion || 'No especificada' }}</span>
            </div>
            <div class="address-item">
              <span class="label">Comuna / ID</span>
              <span class="value">{{ comuna }}</span>
            </div>
            <div class="address-item">
              <span class="label">Estado</span>
              <span class="value status-pill">Sincronizado</span>
            </div>
          </div>
        </div>

        <div class="patients-section">
          <div v-for="c in clientes_calculated" :key="c.id" class="patient-detail-card">
            <div class="patient-card-header">
              <div class="patient-main-meta">
                <h3>{{ c.nombre }} {{ c.apellido }}</h3>
                <span class="rut-tag">{{ c.rut }}</span>
                <span class="insurance-tag">{{ c.asegurador.nombre }}</span>
              </div>
              <div class="patient-quick-stats">
                 <span class="status-badge" :class="necesitaReceta(c.id) ? 'status-yes' : 'status-no'">
                    {{ necesitaReceta(c.id) ? 'Requiere Orden Médica' : 'Sin Orden Pendiente' }}
                  </span>
              </div>
            </div>

            <div class="patient-card-content">
              <div class="info-column">
                <label>Contacto y Bio</label>
                <div class="data-group">
                  <p><strong>Tel:</strong> {{ c.telefono }}</p>
                  <p class="sub-text">{{ c.email }}</p>
                </div>
                <div class="data-group">
                  <p><strong>Bio:</strong> {{ c.sexo_biologico == 'm' ? 'M' : 'F' }} • {{ calcularEdad(c.fecha_nacimiento) }} años</p>
                  <p class="sub-text">{{ formatFechaLarga(c.fecha_nacimiento) }}</p>
                </div>
              </div>

              <div class="info-column border-sides">
                <label>Exámenes Solicitados</label>
                <div class="exam-tags-container">
                  <div v-for="e in items.filter(z => z.cliente_id == c.id)" :key="e.id" class="exam-tag">
                    {{ e.nombre || 'Examen' }}
                  </div>
                </div>
              </div>

              <div class="info-column">
                <label>Documentación</label>
                <div class="prescription-manager">
                  <div v-for="r in recetas.filter(x => x.cliente_id == c.id)" :key="r.id" class="file-row">
                    <a :href="r.link" target="_blank" class="file-link">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path></svg>
                      Receta #{{ r.id }}
                    </a>
                    <button @click="marcarRevisada(r.id)" class="check-btn" :class="{ 'is-checked': r.revisada == 1 }">
                      {{ r.revisada == 1 ? 'Revisada' : 'Pendiente' }}
                    </button>
                  </div>
                  <label :for="'file' + c.id" class="add-file-btn">
                    + Subir Receta
                    <input :id="'file' + c.id" :ref="'file' + c.id" type="file" @change="subir_receta(c.id)" hidden>
                  </label>
                </div>
              </div>

              <div class="info-column bg-light">
                <label>Administrativo</label>
                <div class="finance-form">
                  <div class="input-inline">
                    <span>Valor:</span>
                    <input v-model="c.costo_total" type="number" class="mini-input">
                  </div>
                  <div class="input-inline">
                    <span>Copago:</span>
                    <input v-model="c.copago" type="number" class="mini-input">
                  </div>
                  <div class="input-inline">
                    <span>Episodio:</span>
                    <input v-model="c.episodio" type="text" class="mini-input">
                  </div>
                  <button class="btn-save-patient" @click="eEpCopVtotal(c.id)">
                    Actualizar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import TopNav from '@/components/TopNav.vue';
import SideNav from '@/components/SideNav.vue';

export default {
  name: 'DetalleOrdenMedica',
  props: ['ordenId'],
  components: { TopNav, SideNav },
  data() {
    return {
      direccion: '', comuna: '', clientes: [], recetas: [], items: [], atendidos: [], clientes_calculated: [],
    }
  },
  methods: {
    initialize() {
      axios.post(window.hostname + '/api/admin/initialize_recetas', { orden_id: this.$route.params.ordenId })
      .then(r => {
        const d = r.data;
        this.clientes = d.clientes;
        this.recetas = d.recetas;
        this.items = d.items;
        this.atendidos = d.atendidos;
        this.direccion = d.direccion;
        this.comuna = d.comuna;
      });
    },
    subir_receta(cid) {
      const fileInput = this.$refs['file' + cid][0];
      if (!fileInput.files.length) return;
      
      const file = fileInput.files[0];
      const ext = file.name.split('.').pop().toLowerCase();
      
      if (['jpg', 'png', 'jpeg', 'pdf'].includes(ext)) {
        const json_ob = JSON.stringify({
          orden_id: this.$route.params.ordenId,
          cliente_id: cid,
        });

        // FIX CRÍTICO: El servidor necesita que el JSON sea un Blob con content-type
        const blob = new Blob([json_ob], { type: 'application/json' });
        
        let data = new FormData();
        data.append("document", blob);
        data.append("file", file);

        axios.post(window.hostname + '/api/admin/agregar_receta', data)
          .then(() => {
            this.initialize();
          })
          .catch(e => console.error(e));
      } else {
        alert("Formato no soportado");
      }
    },
    eEpCopVtotal(cid) {
      const target = this.clientes_calculated.find(x => x.id == cid);
      axios.post(window.hostname + '/api/admin/modificar_copago_episodio_ct', { 
        orden_id: this.$route.params.ordenId, cliente_id: cid, copago: target.copago, episodio: target.episodio, costo_total: target.costo_total 
      }).then(() => {
        this.initialize();
        alert("Actualizado");
      });
    },
    marcarRevisada(receta_id) {
      axios.post(window.hostname + '/api/admin/receta_marcar_como_revisado', { receta_id }).then(() => this.initialize());
    },
    necesitaReceta(cliente_id) {
      const pItems = this.items.filter(z => z.cliente_id == cliente_id);
      return pItems.some(item => {
        const ex = this.examenes.find(x => x.id == item.examen_id);
        return ex ? ex.requiere_orden == 1 : false;
      });
    },
    formatFechaLarga(f) {
      if(!f) return '-';
      const meses = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];
      return `${f.d} de ${meses[f.m - 1]} de ${f.a}`;
    },
    calcularEdad(f) {
      if(!f) return 0;
      const hoy = new Date();
      const cumple = new Date(f.a, f.m - 1, f.d);
      let edad = hoy.getFullYear() - cumple.getFullYear();
      if (hoy.getMonth() < cumple.getMonth() || (hoy.getMonth() === cumple.getMonth() && hoy.getDate() < cumple.getDate())) edad--;
      return edad;
    }
  },
  computed: { ...mapGetters(['examenes', 'prestador']) },
  watch: {
    clientes: {
      handler() {
        this.clientes_calculated = this.clientes.map(cli => {
          const a = this.atendidos.find(at => at.cliente_id == cli.id) || {};
          return { ...cli, copago: a.copago || 0, costo_total: a.costo_total || 0, episodio: a.episodio || 0 };
        });
      }, deep: true
    }
  },
  created() { this.initialize(); }
}
</script>

<style scoped>
.page-container { display: flex; background-color: #f8fafc; min-height: 100vh; font-family: -apple-system, sans-serif; }
.column-right { flex: 1; padding-left: 275px; }
.detalle-container { padding: 30px; max-width: 1250px; margin: 0 auto; }

/* Notion Style Elements */
.order-header-card { background: white; border-radius: 12px; padding: 24px; box-shadow: 0 1px 3px rgba(0,0,0,0.1); margin-bottom: 24px; border: 1px solid #e2e8f0; }
.main-title { font-size: 1.5rem; font-weight: 700; color: #1e293b; margin: 0; }
.order-badge { background: #e0f2fe; color: #0369a1; padding: 4px 12px; border-radius: 20px; font-weight: 700; font-size: 0.8rem; margin-bottom: 10px; display: inline-block; }

.address-grid { display: grid; grid-template-columns: 2fr 1fr 1fr; gap: 20px; padding-top: 15px; border-top: 1px solid #f1f5f9; }
.address-item .label { display: block; font-size: 0.7rem; color: #94a3b8; text-transform: uppercase; font-weight: 700; margin-bottom: 4px; }
.address-item .value { font-weight: 600; color: #334155; font-size: 0.9rem; }

.patient-detail-card { background: white; border-radius: 12px; border: 1px solid #e2e8f0; margin-bottom: 24px; overflow: hidden; box-shadow: 0 1px 2px rgba(0,0,0,0.05); }
.patient-card-header { background: #f8fafc; padding: 15px 24px; display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #e2e8f0; }
.patient-main-meta h3 { margin: 0; font-size: 1rem; font-weight: 700; }
.rut-tag { background: #fff; border: 1px solid #cbd5e1; padding: 2px 8px; border-radius: 4px; font-size: 0.75rem; font-family: monospace; margin: 0 10px; }
.insurance-tag { color: #6366f1; font-size: 0.75rem; font-weight: 700; text-transform: uppercase; }

.patient-card-content { display: grid; grid-template-columns: 1fr 1.2fr 1fr 1fr; }
.info-column { padding: 20px; }
.border-sides { border-left: 1px solid #f1f5f9; border-right: 1px solid #f1f5f9; }
.bg-light { background-color: #fafbfc; }

.info-column label { font-size: 0.65rem; text-transform: uppercase; color: #94a3b8; font-weight: 800; margin-bottom: 15px; display: block; }
.data-group p { margin: 0; font-size: 0.85rem; font-weight: 500; }
.sub-text { font-size: 0.75rem; color: #64748b; }

.exam-tag { background: #f0fdf4; color: #166534; border: 1px solid #bbf7d0; padding: 4px 8px; border-radius: 6px; font-size: 0.7rem; margin-bottom: 5px; display: inline-block; margin-right: 5px; }

.file-row { display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; font-size: 0.8rem; }
.file-link { color: #2563eb; text-decoration: none; font-weight: 600; }
.check-btn { font-size: 0.7rem; padding: 2px 6px; border-radius: 4px; border: 1px solid #e2e8f0; background: #fff; cursor: pointer; }
.check-btn.is-checked { background: #dcfce7; color: #15803d; border-color: #bbf7d0; }
.add-file-btn { margin-top: 10px; display: block; text-align: center; border: 1px dashed #cbd5e1; padding: 8px; border-radius: 8px; font-size: 0.75rem; font-weight: 600; cursor: pointer; color: #64748b; }

.finance-form { display: flex; flex-direction: column; gap: 8px; }
.input-inline { display: flex; justify-content: space-between; align-items: center; font-size: 0.8rem; }
.mini-input { width: 75px; padding: 4px 8px; border: 1px solid #cbd5e1; border-radius: 4px; text-align: right; }
.btn-save-patient { background: #1e293b; color: white; border: none; padding: 8px; border-radius: 6px; font-size: 0.8rem; cursor: pointer; margin-top: 5px; }

.status-badge { padding: 4px 10px; border-radius: 20px; font-size: 0.7rem; font-weight: 700; }
.status-yes { background: #fff1f2; color: #e11d48; }
.status-no { background: #f0fdf4; color: #16a34a; }
.status-pill { background: #fef3c7; color: #92400e; padding: 2px 10px; border-radius: 12px; font-size: 0.7rem; font-weight: 600; }

@media (max-width: 1024px) {
  .patient-card-content { grid-template-columns: 1fr 1fr; }
  .column-right { padding-left: 0; }
}
</style>